var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-promise',{staticClass:"the-document-entries",attrs:{"promise":_vm.getProductInfolist},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return _vm._l((data),function(entry,key,index){return _c('the-document-entry',{key:index,staticClass:"entry",attrs:{"entryType":key,"entry":entry}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }